<template>
  <div class="contacts-page">
    <section class="contacts-hero" ref="root">
      <div class="contacts-hero__inner" :class="{ 'contacts-hero__inner_visible': visible }">
        <h1 class="contacts-hero__title">Контакты</h1>
        <p class="contacts-hero__subtitle">
          Пишите в мессенджеры или оставьте заявку — мы ответим в ближайшее время.
        </p>

        <div v-if="loading" class="contacts-hero__loading">
          <Loader inverse size="lg" />
        </div>
        <div v-else class="contacts-hero__grid">
          <a
            v-for="(item, i) in items"
            :key="item.type"
            :href="item.url"
            target="_blank"
            rel="noopener noreferrer"
            class="contacts-hero__card"
            :style="{ transitionDelay: visible ? `${0.1 + i * 0.08}s` : '0s' }"
          >
            <span class="contacts-hero__icon" v-html="iconSvg(item.type)" :aria-label="item.label"></span>
            <span class="contacts-hero__label">{{ item.label }}</span>
          </a>
        </div>

        <div class="contacts-hero__cta-wrap">
          <button type="button" class="contacts-hero__cta" @click="openQuestionForm">
            Напишите нам
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import Loader from '@/components/Loader.vue'

const ICONS = {
  telegram: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>`,
  instagram: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a3.998 3.998 0 100 8 3.998 3.998 0 000-8zm0 6.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm5.5-6.5a.9.9 0 100 1.8.9.9 0 000-1.8zm-11 0a.9.9 0 100 1.8.9.9 0 000-1.8z"/></svg>`,
  tiktok: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1.05-.08 6.33 6.33 0 00-6.33 6.33 6.33 6.33 0 0010.86 4.5v-6.5a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/></svg>`
}

export default {
  name: 'Contacts',
  components: { Loader },
  setup() {
    const store = useStore()
    const root = ref(null)
    const visible = ref(false)

    const items = computed(() => store.getters['contacts/items'])
    const loading = computed(() => store.getters['contacts/loading'])

    function iconSvg(type) {
      return ICONS[type] || ''
    }

    function openQuestionForm() {
      store.commit('setQuestionModalOpen', true)
    }

    onMounted(() => {
      store.dispatch('contacts/fetchContacts')
      requestAnimationFrame(() => { visible.value = true })
    })

    return { root, visible, items, loading, iconSvg, openQuestionForm }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

$dur: 0.6s;
$ease: cubic-bezier(0.22, 1, 0.36, 1);

.contacts-page {
  min-height: 60vh;
}

.contacts-hero {
  padding: 100px $gap 80px;
  background: $color-bg-alt;
  color: $color-primary-inverse;

  @media (max-width: $breakpoint-mobile) {
    padding: 72px $gap 56px;
  }

  &__inner {
    max-width: $container-max;
    margin: 0 auto;
    text-align: center;
  }

  &__title {
    font-size: clamp(32px, 5vw, 44px);
    font-weight: 800;
    letter-spacing: -0.02em;
    margin: 0 0 16px;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity $dur $ease, transform $dur $ease;

    .contacts-hero__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__subtitle {
    font-size: clamp(15px, 1.8vw, 18px);
    color: rgba(255, 255, 255, 0.78);
    margin: 0 0 48px;
    max-width: 480px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.5;
    opacity: 0;
    transform: translateY(16px);
    transition: opacity $dur $ease, transform $dur $ease;
    transition-delay: 0.06s;

    .contacts-hero__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__loading {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 160px;
    margin-bottom: 40px;
  }

  &__grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 28px 32px;
    margin-bottom: 48px;
  }

  &__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    width: 160px;
    padding: 32px 24px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 20px;
    color: $color-primary-inverse;
    text-decoration: none;
    font-weight: 600;
    font-size: 17px;
    letter-spacing: 0.02em;
    transition: background $dur $ease, border-color $dur $ease, transform 0.25s $ease, box-shadow 0.25s $ease;
    opacity: 0;
    transform: translateY(20px);

    .contacts-hero__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }

    &:hover {
      background: rgba(255, 255, 255, 0.14);
      border-color: $color-accent-teal;
      transform: translateY(-4px);
      box-shadow: 0 16px 40px rgba(0, 0, 0, 0.2);
    }
    &:focus-visible {
      outline: 2px solid $color-accent-teal;
      outline-offset: 4px;
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 72px;
    color: $color-accent-teal;
    flex-shrink: 0;

    :deep(svg) {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  &__label {
    display: block;
  }

  &__cta-wrap {
    opacity: 0;
    transform: translateY(16px);
    transition: opacity $dur $ease, transform $dur $ease;
    transition-delay: 0.2s;

    .contacts-hero__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__cta {
    padding: 16px 40px;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: $color-primary-inverse;
    background: $color-accent-teal;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    font-family: inherit;
    box-shadow: 0 8px 28px rgba(97, 130, 111, 0.45);
    transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;

    &:hover {
      opacity: 0.95;
      box-shadow: 0 12px 36px rgba(97, 130, 111, 0.55);
    }
    &:active {
      transform: scale(0.98);
    }
  }
}
</style>
